var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Badge } from '../elements/badge';
import { ContentNode } from './content-node';
import { Icon } from '../elements/icon';
import { useEntity } from '../hooks/use-entity';
import { useIcons, TickIconGlyph } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
var cls = classNames('task-item');
export var TaskItemDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["  \n    list-style-type: none;\n    color: ", ";\n    padding: 0;\n    font-weight: 400;\n    margin: 0;\n    display: flex;\n    align-items: flex-start;\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["  \n    list-style-type: none;\n    color: ", ";\n    padding: 0;\n    font-weight: 400;\n    margin: 0;\n    display: flex;\n    align-items: flex-start;\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])), theme.COLOR('strong'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 1px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    margin-top: 1px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "])))
});
var BulletStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border: 2px solid ", ";\n    background: ", ";\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "], ["\n    border: 2px solid ", ";\n    background: ", ";\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "])), theme.COLOR('strong'), theme.COLOR('light'), theme.UNIT(4), theme.UNIT(4), theme.UNIT(2), function (_a) {
    var isComplete = _a.isComplete;
    return isComplete && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: ", ";\n      border-color: ", ";\n    "], ["\n      background: ", ";\n      border-color: ", ";\n    "])), theme.COLOR('green'), theme.COLOR('green'));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    font-size: 1em;\n    align-items: flex-start;\n    ", "\n  "], ["\n    display: flex;\n    font-size: 1em;\n    align-items: flex-start;\n    ", "\n  "])), function (_a) {
    var isComplete = _a.isComplete;
    return isComplete && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      // text-decoration: line-through;\n      color: ", ";\n    "], ["\n      // text-decoration: line-through;\n      color: ", ";\n    "])), theme.COLOR('green'));
  })
});
var BadgeStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-left: ", ";\n    position: relative;\n    line-height: 18px;\n    top: -2px;\n  "], ["\n    margin-left: ", ";\n    position: relative;\n    line-height: 18px;\n    top: -2px;\n  "])), theme.UNIT(2))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-top: ", ";\n    font-size: 1em;\n    font-weight: 400;\n    color: ", ";\n  "], ["\n    margin-top: ", ";\n    font-size: 1em;\n    font-weight: 400;\n    color: ", ";\n  "])), theme.UNIT(2), theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: styled.li(templateObject_11 || (templateObject_11 = __makeTemplateObject([""], [""]))),
  Bullet: styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BulletStyles),
  Icon: styled(Icon)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Body: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Header: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Name: styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Badge: styled(Badge)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  Description: styled(ContentNode)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
My.Container = styled.li(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ContainerStyles);
export var TaskItem = function (props) {
  var className = props.className,
    children = props.children,
    showDetails = props.showDetails;
  var entity = useEntity(props.entity);
  var completed = entity.completed,
    due = entity.due,
    description = entity.description,
    name = entity.name;
  var icons = useIcons();
  var t = useLang();
  var hasDescription = showDetails && description && !!description.text;
  var hasDueDate = !!due;
  var isComplete = !!completed;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Bullet, {
    isComplete: isComplete
  }, isComplete && React.createElement(My.Icon, {
    size: 12,
    color: "light"
  }, React.createElement(TickIconGlyph, null))), React.createElement(My.Body, null, React.createElement(My.Header, {
    _hasBorder: showDetails
  }, React.createElement(My.Name, {
    isComplete: isComplete
  }, name, isComplete && React.createElement(My.Badge, {
    colors: {
      background: 'green'
    }
  }, t('Completed')))), hasDescription && React.createElement(My.Description, {
    entity: description
  })));
};
TaskItem.defaultProps = TaskItemDefaultProps;
TaskItem.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;